import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import type { Response, ProductCategory } from "../interfaces";

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    getCategories: builder.query<Response<ProductCategory[]>, void>({
      query: () => ({
        url: "categories",
        method: "GET",
      }),
      providesTags: ["Category"],
    }),
    getCategory: builder.query<Response<ProductCategory>, string>({
      query: (id) => ({
        url: `categories/${id}`,
        method: "GET",
      }),
      providesTags: ["Category"],
    }),
    createCategory: builder.mutation<
      Response<ProductCategory>,
      Partial<ProductCategory>
    >({
      query: (category) => ({
        url: "categories",
        method: "POST",
        data: category,
      }),
      invalidatesTags: ["Category"],
    }),
    updateCategory: builder.mutation<
      Response<ProductCategory>,
      { id: string; data: Partial<ProductCategory> }
    >({
      query: ({ id, data }) => ({
        url: `categories/${id}`,
        method: "PUT",
        data,
      }),
      invalidatesTags: ["Category"],
    }),
    deleteCategory: builder.mutation<Response<void>, string>({
      query: (id) => ({
        url: `categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Category"],
    }),
    toggleCategoryStatus: builder.mutation<
      Response<ProductCategory>,
      { id: string; is_active: boolean }
    >({
      query: ({ id, is_active }) => ({
        url: `categories/${id}/status`,
        method: "PATCH",
        data: { is_active },
      }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useToggleCategoryStatusMutation,
} = categoryApi;

